import { Injectable,  OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ParamFilters } from '../models/filtermodels/ParamFilters';
import { TVAngebot } from '../models/sktv/TVAngebot';
import { AuthGuardService } from './auth-guard.service';
import { Favorite } from '@app/models/favorites/Favorite';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class FavoritesService implements OnDestroy {
    private contentAuthSubject: BehaviorSubject<number>;
    private favoriteslistSubject: BehaviorSubject<Favorite[]>;
    private unsubscribe$ = new Subject();
    private favoritesCountBroadcastChannel?: BroadcastChannel;
    private favoriteslist: Favorite[];
    partnerid: string = '';
    constructor(private authGuard: AuthGuardService, @Inject(PLATFORM_ID) private platformId: any,) {
        this.contentAuthSubject = new BehaviorSubject(null);
        this.favoriteslistSubject = new BehaviorSubject([]);
        this.favoriteslist = [];
        this.initPartner();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
        this.favoritesCountBroadcastChannel?.close();
    }

    async initPartner() {
        this.authGuard.getPartnerid$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.length > 0) {
                if (this.partnerid !== res) {
                    this.favoritesCountBroadcastChannel?.close();
                    this.favoritesCountBroadcastChannel = undefined;
                }
                this.partnerid = res;
                this.initfromslocalstorage();
            }
        });
    }

    inFavorites(code: string): boolean {
        code = '' + code;
        let found = false;
        if (code?.length > 0) {
            for (let i = 0; i < this.favoriteslist.length; i++) {
                const tmp_code = (this.favoriteslist[i].hotel?.code || this.favoriteslist[i]?.hotel?.references?.giataIds?.[0]) + '';
                if (tmp_code === code) {
                    found = true;
                    i = this.favoriteslist.length;
                }
            }
        }
        return found;
    }

    inFavoritesFerien(code: string): boolean {
        if (this.favoriteslist?.length > 0) {
            return this.favoriteslist.find(el => { return el?.ferienHauser?.id === code }) !== undefined;
        } else {
            return false;
        }
    }

    inFavoritesCruise(code: string): boolean {
        if (this.favoriteslist?.length > 0) {
            return this.favoriteslist.find(el => { return el?.cruise?.cruise_id === code }) !== undefined;
        } else {
            return false;
        }
    }

    async addHotel(hotel: any, params: ParamFilters) {
        // console.log(hotel);
        delete params.tourOperatorList;
        delete params.flight;
        delete params.boardTypeList;
        delete params.minCategory;
        delete params.transferlist;
        if (hotel?.code?.length > 0 || hotel?.references?.giataIds?.[0]) {
            this.favoriteslist.push({ hotel: hotel, params: params });
            window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
        }
        this.emitFavoritesList();
    }

    async addSktv(sktvContent: TVAngebot, params: ParamFilters) {
        delete params.tourOperatorList;
        delete params.flight;
        delete params.boardTypeList;
        delete params.minCategory;
        delete params.transferlist;
        if (sktvContent?.bookingcode?.length > 0) {
            this.favoriteslist.push({ sktvContent: sktvContent, params: params });
            window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
        }
        this.emitFavoritesList();
    }

    async removeHotel(code: string) {
        code = '' + code;
        if (code?.length > 0) {
            for (let i = 0; i < this.favoriteslist.length; i++) {
                const tmp_code = (this.favoriteslist[i].hotel?.code || this.favoriteslist[i]?.hotel?.references?.giataIds?.[0]) + '';
                if (tmp_code === code) {
                    this.favoriteslist.splice(i, 1);
                    i = this.favoriteslist.length;
                }
            }
            this.emitFavoritesList();
            window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
        }
    }

    async removeSktv(code: string) {
        if (code?.length > 0) {
            for (let i = 0; i < this.favoriteslist.length; i++) {
                if (this.favoriteslist[i].sktvContent?.bookingcode === code) {
                    this.favoriteslist.splice(i, 1);
                    i = this.favoriteslist.length;
                }
            }
            this.emitFavoritesList();
            window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
        }
    }

    async removeFerienhauser(code) {
        if (code?.length > 0) {
            for (let i = 0; i < this.favoriteslist.length; i++) {
                if (this.favoriteslist[i].ferienHauser?.id === code) {
                    this.favoriteslist.splice(i, 1);
                    i = this.favoriteslist.length;
                }
            }
            this.emitFavoritesList();
            window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
        }
    }

    async removeKrz(code) {
        if (code?.length > 0) {
            for (let i = 0; i < this.favoriteslist.length; i++) {
                if (this.favoriteslist[i].cruise?.cruise_id === code) {
                    this.favoriteslist.splice(i, 1);
                    i = this.favoriteslist.length;
                }
            }
            this.emitFavoritesList();
            window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
        }
    }

    async addFerienhauser(haus) {
        this.favoriteslist.push(haus);
        this.emitFavoritesList();
        window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
    }

    async addKrz(cruise) {
        this.favoriteslist.push({ cruise: cruise });
        this.emitFavoritesList();
        window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
    }

    async initfromslocalstorage() {
        if (isPlatformBrowser(this.platformId)) {
            const tmpStr = window.localStorage.getItem(this.partnerid + '_favorites');
            if (tmpStr?.length > 0) {
                try {
                    this.favoriteslist = JSON.parse(tmpStr);
                } catch (error) {
                    window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
                }
            } else {
                window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
            }
            this.emitFavoritesList();
        }
    }

    async resetFavoritesList() {
        this.favoriteslist = [];
        window.localStorage.setItem(this.partnerid + '_favorites', JSON.stringify(this.favoriteslist));
        this.emitFavoritesList();
    }

    private emitFavoritesList() {
        const count = this.favoriteslist.length;
        this.contentAuthSubject.next(count);
        this.favoriteslistSubject.next(this.favoriteslist);
        this.broadcastFavoritesCount(count);
    }

    private broadcastFavoritesCount(count: number) {
        const favoritesCountBroadcastChannel = this.getFavoritesCountBroadcastChannel();
        if (!favoritesCountBroadcastChannel) {
            return;
        }
        favoritesCountBroadcastChannel.postMessage({
            type: 'favorites-count',
            partnerid: this.partnerid,
            count: count,
        });
    }

    private getFavoritesCountBroadcastChannel(): BroadcastChannel | null {
        if (!isPlatformBrowser(this.platformId) || typeof BroadcastChannel === 'undefined') {
            return null;
        }
        if (!this.favoritesCountBroadcastChannel) {
            this.favoritesCountBroadcastChannel = new BroadcastChannel(this.getFavoritesCountChannelName());
            this.favoritesCountBroadcastChannel.onmessage = (event) => {
                if (event?.data?.type === 'get-favorites-count') {
                    this.broadcastFavoritesCount(this.favoriteslist.length);
                }
            };
        }
        return this.favoritesCountBroadcastChannel;
    }

    private getFavoritesCountChannelName(): string {
        return '_favorites_count_' + this.partnerid;
    }

    get favoritslist$() {
        return this.favoriteslistSubject.asObservable();
    }

    get favorites$() {
        return this.contentAuthSubject.asObservable();
    }
}
